import React, { Component } from 'react'
import { action, isObservableArray, toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Checkbox } from 'antd'
import _sortBy from 'lodash/sortBy'

const MAX_PARAMS = 3

@inject('view')
@observer
class DataTypeControl extends Component {
  UNSAFE_componentWillReceiveProps ({ view, category, dataTypes, kind }) { // eslint-disable-line
    const selectedTypes = view.getDataTypeIds({ kind, categoryId: category.id })
    const dataTypeIds = isObservableArray(selectedTypes) ? toJS(selectedTypes) : selectedTypes || []
    // if (kind === 'response') {
    //   console.log({ kind, selectedTypes, dataTypeIds })
    // }
    if (!dataTypeIds.length) {
      const defaultDataTypes = dataTypes.filter(dt => dt.default).map(dt => dt.id)
      this.handleDataTypeToggle(defaultDataTypes)
    }
  }
  @action.bound
  handleDataTypeToggle (values) {
    const { view, category, kind } = this.props
    if (values.length > 0 && values.length <= MAX_PARAMS) {
      view.setDataTypeIds({
        kind,
        categoryId: category.id,
        dataTypeIds: values
      })
    }
  }

  render () {
    const { view, category, dataTypes, kind } = this.props
    const { name } = category
    const selectedTypes = view.getDataTypeIds({ kind, categoryId: category.id })
    const dataTypeIds = isObservableArray(selectedTypes) ? selectedTypes.toJS() : selectedTypes || []

    // const parameters = _sortBy(dataTypes, 'ranking').map(type => ({
    //   label: type.name,
    //   value: type.id
    // }))
    // console.log({ dataTypes }, dataTypes.filter(dt => dt.default).map(dt => `${dt.id}`))
    return <div>
      {name}
      <Checkbox.Group
        // options={parameters}
        onChange={this.handleDataTypeToggle}
        defaultValue={dataTypes.filter(dt => dt.default).map(dt => `${dt.id}`)}
        value={dataTypeIds}
      >
        {_sortBy(dataTypes, 'ranking').map(type => {
          return (
            <div key={type.id}>
              <Checkbox value={type.id}>
                {type.name}
              </Checkbox>
            </div>
          )
        }
        )}
      </Checkbox.Group>
    </div>
  }
}
export default DataTypeControl



// WEBPACK FOOTER //
// ./src/components/DataTypeControl.js